/*
 * @Author: your name
 * @Date: 2024-07-15 09:22:13
 * @LastEditTime: 2024-07-15 09:31:35
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \ep-admin-management\src\views\form\main.ts
 */
import { createApp } from "vue";
import Index from "./index.vue";
import router from "@/views/form/routers";
import { axios } from '@/utils/request'
import 'vant/lib/index.css';
import "@/assets/css/global.less"
import 'ant-design-vue/dist/antd.css';
import { i18n } from '@/i18n';

const app = createApp(Index);
app
  .use(router)
  .use(axios)
  .use(i18n)
  .mount("#app");
